import { conditions } from "../../helpers/conditions/conditions";
import {handleHasXTokenParamOrSendXToken, responseValidator} from "../../helpers/helpers";
import { ConditionName, UserQuizStatus } from "../../interfaces/enums";
import { IQuizQuestions, IUserQuestions, IQuizUserRecords, QuizType, IQuizChoice } from "../../interfaces/interfaces";
import { apiCaller } from "../../services/apiCaller";
import { API } from "../../services/services";
import store from "../store";
import { setChances, setMaxChances, setUserAnswerId, setUserQuestionId, setUserQuestions, setUserStatus } from "../slices/quizSlice";
import { toast } from "mobin-toast";

export const handleHashInLocalStorage = (hash:string) => localStorage.setItem("quiz-hash",hash);

export const handleSelectedAnswer = async (answerId:number, setShowSpinner: (value:undefined | number) => void) => {
    setShowSpinner(answerId);
    const dispatch = store.dispatch;
    const { quiz } = store.getState().quiz;
    let quizHash: any = localStorage.getItem("quiz-hash");
    const answer = {
        quiz: {
            id: quiz.id,
            questions: [{ id: lastQuizQuestionId(quiz), choices: [{ id: answerId }] }],
        },
        encrypted_quiz: quiz.encrypted_quiz,
        hash: quizHash ?? undefined
    }
    const { data, status } = await apiCaller({ url: API().live.quiz, method: "POST", data: answer, headers: handleHasXTokenParamOrSendXToken() });
    if(responseValidator(status)) {
        handleHashInLocalStorage(data.hash);
        dispatch(setUserAnswerId(answerId));
    } else if (data) toast({ type: "error", title: "درخواست منقضی شده است." });
    setShowSpinner(undefined);
}
export const firstQuizQuestion = (quiz: QuizType) => quiz.questions[0];
export const firstQuizQuestionId = (quiz:QuizType) => firstQuizQuestion(quiz).id;

export const lastQuizQuestion = (quiz: QuizType, general?: boolean) => (!!general ? quiz.questions[quiz.number_of_questions - 1] : quiz.questions[quiz.questions.length - 1]);
export const lastQuizQuestionId = (quiz:QuizType, general?: boolean) => {
    const result = lastQuizQuestion(quiz, general);
    if(result) return result.id;
    else return 0
};
export const lastQuizQuestionStatus = (quiz: QuizType) => quiz.questions.length ? lastQuizQuestion(quiz).status : undefined;
export const lastQuizQuestionChoices = (quiz:QuizType) => lastQuizQuestion(quiz).choices;
export const lastQuizQuestionOrder = (quiz:QuizType) => lastQuizQuestion(quiz).order;
export const lastQuizQuestionText = (quiz:QuizType) => lastQuizQuestion(quiz).text;
export const findParticipantsInEliminationQuiz = (quiz: QuizType) => firstQuizQuestion(quiz).choices.find((choice: any) => choice.is_correct === true)!.participants;
export const findCorrectQuizAnswer = (quiz: QuizType) => lastQuizQuestion(quiz).choices.find((choice: any) => choice.is_correct === true)!;

export const handleUserStatus = (chance?: number) => {
    if(!conditions(ConditionName.isLogin)) return UserQuizStatus.viewer;
    else if(conditions(ConditionName.isPointsQuiz)) return UserQuizStatus.participant;
    else return chance !== undefined && chance > 0 ? UserQuizStatus.participant : UserQuizStatus.loser;
}
export const handleCurrentQuestion = (data: IQuizUserRecords) => {
    const dispatch = store.dispatch;
    const { quiz } = store.getState().quiz; 
    const currentQuestionIdInAggregate = handleCurrentQuestionInAggregate(quiz).id;
    const currentUserQuestion = data.question.find((item: IUserQuestions) => +item.id === currentQuestionIdInAggregate);
    dispatch(setUserQuestionId(currentUserQuestion ? +currentUserQuestion.id : 0));
    return currentUserQuestion ?? {}
}

export const handleCurrentQuestionInAggregate = (quiz: QuizType) => quiz.questions[quiz.questions.length - 1];

export const handleUserAnswerId = (data: IQuizUserRecords) => {
    const question: any = data.question ? handleCurrentQuestion(data) : {};
    if(Object.keys(question).length) return +question.choice.id;
    else return 0;
}

export const handleCorrectAnswer = () => {
    const {quiz} = store.getState().quiz;
    return handleCurrentQuestionInAggregate(quiz).choices.find((choice: any) => choice.is_correct === true)!;
}

export const handleUserAnswersCount = () => {
    const { userQuestions } = store.getState().quiz;
    return userQuestions.length;
}

export const handleUserCorrectAnswersCount = (userQuestions:IUserQuestions[]) => {
    const { quiz } = store.getState().quiz;
    let userCorrectAnswerCounts = 0;
    if(userQuestions.length) {
        quiz.questions.map((question: IQuizQuestions) => {
            const correctChoice = question.choices.find((choice:IQuizChoice) => choice.is_correct === true);
            if(correctChoice && userQuestions.find((question:IUserQuestions) => +question.choice.id === correctChoice.id)) userCorrectAnswerCounts +=1;
        });
    }
    return userCorrectAnswerCounts;
}

export const isUserAnswerFirstQuestion = () => {
    const { quiz, userQuestions } = store.getState().quiz;
    const isUserAnswerFirstQuestion = userQuestions.find((question: IUserQuestions) => +question.id === quiz.questions[0].id);
    return !!isUserAnswerFirstQuestion;
}

export const isUserAnswerLastQuestion = () => {
    const { quiz, userQuestions } = store.getState().quiz;
    const isUserAnswerLastQuestion = !!quiz.questions[quiz.number_of_questions - 1] && userQuestions.find((question: IUserQuestions) => +question.id === quiz.questions[quiz.number_of_questions - 1].id);
    return !!isUserAnswerLastQuestion;
}

export const handleUserChancesCount = (userQuestions: IUserQuestions[]) => {
    const dispatch = store.dispatch;
    const { quiz, maxChances } = store.getState().quiz;
    const quizQuestionsCount = quiz.questions.length;
    let chancesCount = maxChances + 1;
    if (quizQuestionsCount === 1 && lastQuizQuestionStatus(quiz) !== 1) {
        if (!userQuestions || (userQuestions && handleUserCorrectAnswersCount(userQuestions) === 0)) chancesCount = chancesCount - 1; 
    }
    else {
        if (lastQuizQuestionStatus(quiz) === 1) {
            if (userQuestions) chancesCount = chancesCount - ((quizQuestionsCount - 1) - handleUserCorrectAnswersCount(userQuestions));
            else chancesCount = chancesCount - (quizQuestionsCount - 1)
        } else {
            if (userQuestions) chancesCount = chancesCount - (quizQuestionsCount - handleUserCorrectAnswersCount(userQuestions));
            else chancesCount = chancesCount - quizQuestionsCount
        }
    }
    dispatch(setChances(chancesCount));
    return chancesCount;
}

export const handleUserRecordesEliminationQuiz = async (quiz:any) => {
    const dispatch = store.dispatch;
    const { data, status } = await apiCaller({ url: API().live.quizUserRecoreds(quiz.type, quiz.id), data: { encrypted_quiz: quiz.encrypted_quiz }, headers: handleHasXTokenParamOrSendXToken() });
    if (responseValidator(status) && data && Object.keys(data).length) {
        dispatch(setUserAnswerId(handleUserAnswerId(data)));
        dispatch(setMaxChances(data.max_chance));
        dispatch(setUserStatus(handleUserStatus(handleUserChancesCount(data.question))));
    }
}

export const handleUserRecordesPointsQuiz = async (quiz: any) => {
    const dispatch = store.dispatch;
    const { data, status } = await apiCaller({ url: API().live.quizUserRecoreds(quiz.type, quiz.id), data: { encrypted_quiz: quiz.encrypted_quiz }, headers: handleHasXTokenParamOrSendXToken() });
    if (responseValidator(status) && data && Object.keys(data).length) {
        dispatch(setUserAnswerId(handleUserAnswerId(data)));
        dispatch(setUserStatus(handleUserStatus()));
        if (data.question) dispatch(setUserQuestions(data.question));
    }
}

export const handleQuizParticipantsPerQuestion = () => {
    const { quiz } = store.getState().quiz;
    let participantsCount = 0;
    lastQuizQuestionChoices(quiz).map((choice:IQuizChoice) => participantsCount += choice.participants);
    return participantsCount;
}